import React from 'react';
import { createGlobalStyle } from 'styled-components';
import InteractiveComponent from './components/presentational/interactive/InteractiveComponent';
export const zIndexes = {
  header: 1,
  notifications: 101,
  dialog: 102,
  skipLink: 103
};

// Breakpoints
export const BP_SM = '576px';
export const BP_MD = '768px';
export const BP_LG = '992px';
export const GlobalStyle = createGlobalStyle`
  :root {
    --dark-grey-blue: #353e55;
    --slate-grey: #596173;
    --orange: #ff7710;
    --purple: #a400f0;
    --orangeish: #ff8f3b;
    --cornflower-blue: #4e78dd;
    --soft-blue: #6e90e3;
    --light-grey-blue: #aeb2bb;
    --light-grey: #e9e9e9;
    --cloudy-blue: #bcc0c7;
    --very-light-pink: #eeeeee;
    --white: #ffffff;

    --lx-dark-blue: #0a4d62;
    --lx-pink: #F0547D;
    --lx-orange: #F6B137;
    --lx-light-blue: #93B7BB;
    --lx-purple: #7E34C9;

    --shamrock: #00ab4f;
    --hot-pink: #fe018e;
    
    --boring-green: #68af63;
    --red: #f55c5c;
    --pale-grey: #f5f6f9;
    --dark-grey: #696b70;

    --charcoal-100:rgba(53, 62, 85, 1);
    --charcoal-90:rgba(53, 62, 85, .9);
    --charcoal-60: rgba(53, 62, 85, 0.6);
    --charcoal-30:rgba(53, 62, 85, 0.3);
    --charcoal-10:rgba(53, 62, 85, 0.1);
    --charcoal-5:rgba(53, 62, 85, 0.05);

    --royal-blue-100: rgba(78, 120, 221, 1);
    --royal-blue-60:rgba(78, 120, 221, 0.6);
    --royal-blue-30:rgba(78, 120, 221, 0.3);
    --royal-blue-10:rgba(78, 120, 221, 0.1);

    --pumpkin-orange:rgba(255, 119, 16, 1);

    --malachite-green:rgba(0, 171, 79, 1);

    --magenta-process:rgba(254, 1, 142, 1);
    
    --amber:rgba(255, 191, 0, 1);

    --info: rgba(78, 120, 221, 1);
    --success: rgba(0, 171, 79, 1);
    --warning: #ff7710;
    --danger: #f55c5c;

    --reach-dialog: 1;
  }
  *, *:before, *:after {
        box-sizing: border-box;
      }
  
  body,
  #root,
  .app {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
  }
  
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;
export const CenterVertically = `
  display: flex;
  align-items: center;
`;
export const CenterHorizontally = `
  display: flex;
  justify-content: center;
`;
export const Center = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const LeftAligned = `
  display: flex;
  justify-content: flex-start;
`;
export const RightAligned = `
  display: flex;
  justify-content: flex-end;
`;
export const BoldFont = `
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
`;
const RegularFont = `
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
`;
export const H1_FONT = `
  ${BoldFont}
  font-size: 48px;
  line-height: 1.21;
`;
export const H2_FONT = `
  ${BoldFont}
  font-size: 36px;
  line-height: 1.19;
`;
export const H3_FONT = `
  ${RegularFont}
  font-size: 24px;
`;
export const H4_FONT = `
  ${BoldFont}
  font-size: 18px;
  line-height: 1.5;
`;
export const REGULAR_FONT = `
  ${RegularFont}
  font-size: 16px;
`;
export const DESCRIPTION_FONT = `
  ${RegularFont}
  font-size: 12px;
`;
export const Row = `
  display: flex;
  flex-wrap: wrap;
  margin-right: -20px;
  margin-left: -20px;
`;
export const ColSm1 = `
  width: 80px;
`;
export const ColSm2 = `
  width: 180px;
`;
export const ColSm6 = `
  width: 580px;
`;
export const ColSm8 = `
  width: 780px;
`;
export const ColSm12 = `
  width: 1180px;
`;
export const ColLg1 = `
  width: 140px;
`;
export const ColLg3 = `
  width: 460px;
`;
export const ColLg4 = `
  width: 620px;
`;
export const ColLg6 = `
  width: 940px;
`;
export const CONTAINER = `
  max-width: 100%;
  width:1180px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  
  @media (min-width: ${BP_MD}) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  
`;

// Aligned with Tailwind - 6 * 0.25rem = 1.5rem;
export const SPACE_Y_2 = `
  > * + * {
    margin-top: 0.5rem;
  }
`;
export const SPACE_Y_6 = `
  > * + * {
    margin-top: 1.5rem;
  }
`;
export const SPACE_X_4 = `
  > * + * {
    margin-left: 1rem;
  }
`;
export const TRUNCATE = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// eslint-disable-next-line react/jsx-props-no-spreading
export const Interactive = props => /*#__PURE__*/React.createElement(InteractiveComponent, props);